<template>

  <div class="product-management-page">
     <Loader
      v-if="loaderEnabled"
      v-bind:logo="loaderLogo"
    ></Loader
    > <b-row
      > <b-col
        md="12"
        lg="12"
        sm="12"
        > <KTCodePreview
          > <template v-slot:preview
            >
            <div class="product-management-page__header">

              <div class="d-flex justify-content-between align-items-center mb-4">

                <h5 class="mb-0">Quản lý sản phẩm sàn thương mại điện tử</h5>
                 <b-button
                  variant="secondary"
                  size="sm"
                  @click="navigateBack"
                  > <i class="flaticon2-back"></i> Quay lại </b-button
                >
              </div>

            </div>

            <div
              v-if="error"
              class="alert alert-danger"
              role="alert"
            >

              <div class="d-flex justify-content-between align-items-center">

                <div>{{ error }}</div>
                 <b-button
                  variant="danger"
                  size="sm"
                  @click="loadConnections"
                  > <i class="flaticon2-refresh"></i> Thử lại </b-button
                >
              </div>

            </div>
             <b-card
              class="product-management-page__controls mb-4"
              body-class="product-management-page__controls-body"
              > <div class="product-management-page__filter-head"
                > <span class="product-management-page__filter-title">Bộ lọc</span>
              </div
                > <b-row class="product-management-page__filter-grid" align-v="start"
                > <b-col cols="12" sm="6" md="6" lg="3"
                  > <b-form-group
                    label="Sàn TMĐT"
                    label-for="platform-select"
                    label-class="product-management-page__filter-label"
                    class="product-management-page__filter-field mb-3 mb-lg-0"
                    > <b-form-select
                      id="platform-select"
                      class="select-style product-management-page__filter-control"
                      v-model="selectedPlatform"
                      :options="platformOptions"
                      @change="onPlatformChange"
                      :disabled="loading || syncing"
                      size="sm"
                      > <template #first
                        > <b-form-select-option
                          :value="null"
                          disabled
                          > -- Chọn sàn -- </b-form-select-option
                        > </template
                      > </b-form-select
                    > </b-form-group
                  > </b-col
                > <b-col cols="12" sm="6" md="6" lg="3"
                  > <b-form-group
                    label="Gian hàng"
                    label-for="shop-select"
                    label-class="product-management-page__filter-label"
                    class="product-management-page__filter-field mb-3 mb-lg-0"
                    > <b-form-select
                      id="shop-select"
                      class="select-style product-management-page__filter-control"
                      v-model="selectedConfigId"
                      :options="shopOptions"
                      :disabled="!selectedPlatform || loading || syncing"
                      @change="onShopChange"
                      size="sm"
                      > <template #first
                        > <b-form-select-option
                          :value="null"
                          disabled
                          > -- Chọn gian hàng -- </b-form-select-option
                        > </template
                      > </b-form-select
                    > </b-form-group
                  > </b-col
                > <b-col cols="12" sm="6" md="6" lg="3"
                  > <b-form-group
                    label="Tên sản phẩm (sàn)"
                    label-for="product-name-search"
                    label-class="product-management-page__filter-label"
                    class="product-management-page__filter-field mb-3 mb-lg-0"
                    > <b-form-input
                      id="product-name-search"
                      class="product-management-page__filter-control"
                      v-model="searchProductName"
                      placeholder="Tìm theo tên hiển thị trên sàn..."
                      size="sm"
                      @keyup.enter="handleApplyFilter"
                    ></b-form-input
                    > </b-form-group
                  > </b-col
                > <b-col cols="12" sm="6" md="6" lg="3"
                  > <b-form-group
                    label="Sản phẩm App (tên/mã)"
                    label-for="app-product-search"
                    class="product-management-page__filter-field product-management-page__filter-field--app mb-3 mb-lg-0"
                    > <b-form-input
                      id="app-product-search"
                      class="product-management-page__filter-control"
                      v-model="searchAppProduct"
                      placeholder="VD: mã SP, tên hệ thống..."
                      size="sm"
                      @keyup.enter="handleApplyFilter"
                    ></b-form-input
                    > <small class="product-management-page__filter-hint"
                      >Chỉ áp dụng SKU đã liên kết SP App</small
                    > </b-form-group
                  > </b-col
                > </b-row
              > <b-row class="product-management-page__filter-grid product-management-page__filter-grid--row2" align-v="start"
                > <b-col cols="12" sm="6" md="6" lg="3"
                  > <b-form-group
                    label="Trạng thái liên kết"
                    label-for="mapping-status-select"
                    label-class="product-management-page__filter-label"
                    class="product-management-page__filter-field mb-3 mb-lg-0"
                    > <b-form-select
                      id="mapping-status-select"
                      class="select-style product-management-page__filter-control"
                      v-model="mappingStatus"
                      :options="mappingStatusOptions"
                      size="sm"
                    ></b-form-select
                    > </b-form-group
                  > </b-col
                > <b-col cols="12" sm="6" md="6" lg="3"
                  > <b-form-group
                    label="Tồn Shopee"
                    label-for="has-shopee-stock-filter"
                    label-class="product-management-page__filter-label"
                    class="product-management-page__filter-field mb-3 mb-lg-0"
                    > <b-form-select
                      id="has-shopee-stock-filter"
                      class="select-style product-management-page__filter-control"
                      v-model="hasShopeeStockFilter"
                      :options="stockFilterOptions"
                      size="sm"
                    ></b-form-select
                    > </b-form-group
                  > </b-col
                > <b-col cols="12" sm="6" md="6" lg="3"
                  > <b-form-group
                    label="Tồn App"
                    label-for="has-app-stock-filter"
                    label-class="product-management-page__filter-label"
                    class="product-management-page__filter-field mb-0"
                    > <b-form-select
                      id="has-app-stock-filter"
                      class="select-style product-management-page__filter-control"
                      v-model="hasAppStockFilter"
                      :options="stockFilterOptions"
                      size="sm"
                    ></b-form-select
                    > </b-form-group
                  > </b-col
                > <b-col
                  class="d-none d-lg-block product-management-page__filter-spacer"
                  lg="3"
                  aria-hidden="true"
                ></b-col
                > </b-row
              > <hr class="product-management-page__filter-toolbar-divider"
              >
              <div class="product-management-page__toolbar">
                <div class="product-management-page__toolbar-group">
                  <b-button
                    variant="primary"
                    size="sm"
                    @click="handleApplyFilter"
                    :disabled="!selectedConfigId || loadingProducts"
                  >
                    <i class="flaticon2-search-1 mr-1"></i> Lọc
                  </b-button>
                  <b-button
                    variant="outline-secondary"
                    size="sm"
                    @click="handleClearFilter"
                    :disabled="!selectedConfigId"
                  >
                    <i class="flaticon2-refresh mr-1"></i> Xóa lọc
                  </b-button>
                </div>
                <div
                  class="product-management-page__toolbar-group product-management-page__toolbar-group--sync"
                >
                  <b-button
                    variant="primary"
                    size="sm"
                    @click="handleSyncAll(true)"
                    :disabled="!selectedConfigId || syncing"
                  >
                    <b-spinner
                      v-if="syncing"
                      small
                      class="mr-1"
                    ></b-spinner>
                    <i
                      v-else
                      class="flaticon2-refresh-1 mr-1"
                    ></i>
                    {{ syncing ? 'Đang đồng bộ...' : 'Đồng bộ tất cả' }}
                  </b-button>
                  <b-button
                    variant="warning"
                    size="sm"
                    @click="handleSyncAll(false)"
                    :disabled="!selectedConfigId || syncing"
                  >
                    <b-spinner
                      v-if="syncing"
                      small
                      class="mr-1"
                    ></b-spinner>
                    <i
                      v-else
                      class="flaticon2-box mr-1"
                    ></i>
                    {{ syncing ? 'Đang đồng bộ...' : 'Đồng bộ không tồn kho' }}
                  </b-button>
                </div>
              </div>
              <b-row
                v-if="syncResult && syncResult.queued !== true"
                class="mt-3"
                > <b-col
                  >
                  <div class="product-management-page__sync-stats">
                     <span class="mr-4"
                      > <strong>{{ syncResult.totalProducts || 0 }}</strong
                      > sản phẩm </span
                    > <span class="text-success mr-4"
                      > <i class="flaticon2-check-mark"></i> {{ syncResult.autoMappedCount || 0 }}
                      đã liên kết </span
                    > <span class="text-warning"
                      > <i class="flaticon2-warning"></i> {{ syncResult.unmappedCount || 0 }} chưa
                      liên kết </span
                    >
                  </div>
                   </b-col
                > </b-row
              > </b-card
            >
            <div
              v-if="!loadingProducts && products.length === 0 && selectedConfigId && !error"
              class="product-management-page__empty"
            >

              <div class="text-center py-5">
                 <i class="flaticon2-box-1 icon-3x text-muted mb-3"></i>
                <h4 class="text-muted mb-3">Chưa có sản phẩm nào</h4>

                <p class="text-muted mb-4">
                   Nhấn "Đồng bộ tất cả" để lấy sản phẩm từ sàn thương mại điện tử
                </p>

              </div>

            </div>

            <div
              v-if="!selectedConfigId && !loading"
              class="product-management-page__empty"
            >

              <div class="text-center py-5">
                 <i class="flaticon2-layers-1 icon-3x text-muted mb-3"></i>
                <h4 class="text-muted mb-3">Chọn gian hàng</h4>

                <p class="text-muted">
                   Vui lòng chọn sàn thương mại điện tử và gian hàng để xem danh sách sản phẩm
                </p>

              </div>

            </div>
             <b-table
              v-if="!loadingProducts && products.length > 0"
              :items="products"
              :fields="tableFields"
              :busy="loadingProducts"
              striped
              hover
              responsive
              show-empty
              class="product-management-page__table"
              > <template #table-busy
                >
                <div class="text-center text-primary my-2">
                   <b-spinner class="align-middle"></b-spinner> <strong class="ml-2"
                    >Đang tải...</strong
                  >
                </div>
                 </template
              > <template #cell(isSyncInventory)="data"
                >
                <div class="text-center">
                   <b-form-checkbox
                    :checked="!!data.item.isSyncInventory"
                    :disabled="isUpdatingSyncInventory(data.item.platformProductId)"
                    @input="handleIsSyncInventoryChange(data.item, $event)"
                  />
                </div>
                 </template
              > <template #cell(image)="data"
                >
                <div class="product-management-page__image">
                   <img
                    v-if="getProductImage(data.item)"
                    :src="getProductImage(data.item)"
                    :alt="data.item.productName"
                  />
                  <div
                    v-else
                    class="product-management-page__image-placeholder"
                  >
                     <i class="flaticon2-image-file"></i>
                  </div>

                </div>
                 </template
              > <template #cell(name)="data"
                >
                <div class="product-management-page__product-names">
                  <div class="product-management-page__name-line">
                    <span class="product-management-page__name-label">Tên trưng bày:</span>
                    <span class="product-management-page__name-value product-management-page__name-value--display">
                      {{ data.item.productName || '—' }}
                    </span>
                  </div>
                  <div class="product-management-page__name-line product-management-page__name-line--system">
                    <span class="product-management-page__name-label">Tên hệ thống:</span>
                    <span
                      class="product-management-page__name-value"
                      :class="{ 'text-muted': isClickbuyProductNameEmpty(data.item) }"
                    >{{ getClickbuyProductNameDisplay(data.item) }}</span>
                  </div>
                  <div class="product-management-page__name-platform text-muted small mt-1">
                    {{ getPlatformName(data.item.platform) }}
                  </div>
                </div>
                 </template
              > <template #cell(sku)="data"> {{ data.item.platformSku }} </template> <template
                #cell(price)="data"
                > {{ formatPrice(data.item.price, data.item.currency) }} </template
              > <template #cell(linkedStoreStock)="data"
                ><span v-if="data.item.linkedStoreStock != null" class="text-nowrap">{{
                  Number(data.item.linkedStoreStock)
                }}</span
                ><span v-else class="text-muted">—</span></template
              > <template #cell(statusAction)="data"
                >
                <div v-if="data.item.mapping">
                   <b-badge variant="success"
                    > <i class="flaticon2-check-mark"></i> Đã liên kết </b-badge
                  >
                  <div class="text-muted small mt-1">
                     Mã: {{ data.item.clickbuyProduct?.productCode }}
                  </div>

                </div>

                <div v-else>
                   <b-button
                    variant="primary"
                    size="sm"
                    @click="handleSyncSingle(data.item)"
                    :disabled="isSyncing(data.item.id)"
                    > <b-spinner
                      v-if="isSyncing(data.item.id)"
                      small
                      class="mr-1"
                    ></b-spinner
                    > <i
                      v-else
                      class="flaticon2-refresh mr-1"
                    ></i
                    > {{ isSyncing(data.item.id) ? 'Đang sync...' : 'Sync' }} </b-button
                  >
                </div>
                 </template
              > </b-table
            >
            <b-row v-if="products.length > 0 || loadingProducts" class="mt-4">
              <b-col>
                <p class="mt-3 text-dark mb-0" style="font-weight: 500">
                  Tổng số: {{ totalItems }}
                </p>
              </b-col>
              <b-col>
                <b-pagination
                  class="custom-pagination"
                  v-if="numberOfPage >= 2"
                  v-model="currentPage"
                  :total-rows="totalItems"
                  :per-page="pageSize"
                  @change="onPageChange"
                  align="right"
                  first-class="page-item-first btn btn-icon btn-sm m-1"
                  prev-class="page-item-prev btn btn-icon btn-sm m-1"
                  next-class="page-item-next btn btn-icon btn-sm m-1"
                  last-class="page-item-last btn btn-icon btn-sm m-1"
                  page-class="btn btn-icon btn-sm border-0 m-1"
                >
                  <template v-slot:first-text>
                    <span><i class="ki ki-double-arrow-back icon-xs"></i></span>
                  </template>
                  <template v-slot:prev-text>
                    <i class="ki ki-arrow-back icon-xs"></i>
                  </template>
                  <template v-slot:next-text>
                    <i class="ki ki-arrow-next icon-xs"></i>
                  </template>
                  <template v-slot:last-text>
                    <span class="text-info">
                      <i class="ki ki-double-arrow-next icon-xs"></i>
                    </span>
                  </template>
                </b-pagination>
              </b-col>
            </b-row>

            <div
              v-if="loadingProducts || loading"
              class="text-center py-5"
            >
               <b-spinner variant="primary"></b-spinner>
              <p class="text-muted mt-3">
                 {{ loading ? 'Đang tải danh sách kết nối...' : 'Đang tải danh sách sản phẩm...' }}
              </p>

            </div>
             </template
          > </KTCodePreview
        > </b-col
      > </b-row
    >
  </div>

</template>

<script>
  import KTCodePreview from '@/view/content/CodePreview.vue'
  import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
  import Loader from '@/view/content/Loader.vue'
  import { getToastInstance } from '@/utils/toastHelper'
  import { mapGetters } from 'vuex'
  import { RepositoryFactory } from '@/repositories/RepositoryFactory'

  const platformRepository = RepositoryFactory.get('platformIntegration')

  export default {
    name: 'ProductManagementPage',
    components: {
      KTCodePreview,
      Loader,
    },
    data() {
      return {
        connections: [],
        products: [],
        loading: false,
        loadingProducts: false,
        syncing: false,
        error: null,
        selectedPlatform: null,
        selectedConfigId: null,
        searchProductName: '',
        searchAppProduct: '',
        mappingStatus: 'all',
        hasShopeeStockFilter: 'all',
        hasAppStockFilter: 'all',
        syncResult: null,
        currentPage: 1,
        pageSize: 20,
        totalItems: 0,
        syncingProductIds: new Set(),
        updatingIsSyncIds: new Set(),
        tableFields: [
          { key: 'image', label: 'Hình ảnh', class: 'text-center' },
          {
            key: 'isSyncInventory',
            label: 'Đồng bộ tồn kho',
            class: 'text-center',
          },
          {
            key: 'name',
            label: 'Tên sản phẩm',
            sortable: false,
            tdClass: 'product-management-page__name-cell',
          },
          { key: 'sku', label: 'SKU', sortable: false },
          { key: 'price', label: 'Giá', sortable: false },
          {
            key: 'shopeeStock',
            label: 'Tồn Shopee',
            sortable: false,
            class: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'linkedStoreStock',
            label: 'Tồn kho liên kết',
            sortable: false,
            class: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'clickbuyTotalStock',
            label: 'Tồn App',
            sortable: false,
            class: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'statusAction',
            label: 'Trạng thái/Thao tác',
            class: 'text-center',
          },
        ],
        mappingStatusOptions: [
          { value: 'all', text: 'Tất cả' },
          { value: 'mapped', text: 'Đã liên kết' },
          { value: 'unmapped', text: 'Chưa liên kết' },
        ],
        stockFilterOptions: [
          { value: 'all', text: 'Tất cả' },
          { value: 'true', text: 'Có tồn (> 0)' },
          { value: 'false', text: 'Không có tồn' },
        ],
      }
    },
    computed: {
      ...mapGetters(['layoutConfig']),
      numberOfPage() {
        return Math.ceil(this.totalItems / this.pageSize) || 1
      },
      loaderEnabled() {
        return !/false/.test(this.layoutConfig('loader.type'))
      },
      loaderLogo() {
        return process.env.BASE_URL + this.layoutConfig('loader.logo')
      },
      platformOptions() {
        const platforms = [...new Set(this.connections.map((c) => c.platform))]
        return platforms.map((platform) => ({
          value: platform,
          text: this.getPlatformName(platform),
        }))
      },
      shopOptions() {
        if (!this.selectedPlatform) return []

        return this.connections
          .filter((c) => c.platform === this.selectedPlatform)
          .map((connection) => ({
            value: connection.id,
            text: connection.shopName,
          }))
      },
    },
    watch: {
      '$route.query': {
        handler(newQuery) {
          this.restoreFromQuery(newQuery)
          if (this.selectedConfigId) {
            this.fetchProducts()
          } else {
            this.products = []
            this.totalItems = 0
          }
        },
      },
    },
    async created() {
      this.loadBreadcrumb()
      await this.loadConnections()
      this.loadQueryParams()
    },
    methods: {
      ...getToastInstance(),

      parseOptionalStockFilter(val) {
        if (val === undefined || val === null || val === '') return 'all'
        const s = String(val).toLowerCase()
        if (s === 'true' || s === '1' || s === 'yes') return 'true'
        if (s === 'false' || s === '0' || s === 'no') return 'false'
        return 'all'
      },

      loadBreadcrumb() {
        this.$store.dispatch(SET_BREADCRUMB, [{ title: 'Kênh bán' }, { title: 'Quản lý sản phẩm' }])
      },

      async loadConnections() {
        try {
          this.loading = true
          this.error = null
          const response = await platformRepository.getConfigs()

          this.connections = (response.items || []).filter((item) => item.status === 'connected')
        } catch (error) {
          console.error('Error loading connections:', error)
          this.error = 'Không thể tải danh sách kết nối. Vui lòng thử lại.'
          this.makeToastFailure('Lỗi khi tải danh sách kết nối')
        } finally {
          this.loading = false
        }
      },

      loadQueryParams() {
        this.restoreFromQuery(this.$route.query)
        if (this.selectedConfigId) {
          this.fetchProducts()
        }
      },

      restoreFromQuery(query) {
        if (query.platform) {
          this.selectedPlatform = query.platform
        }
        if (query.configId) {
          const connection = this.connections.find((c) => String(c.id) === String(query.configId))
          if (connection) {
            this.selectedPlatform = connection.platform
            this.selectedConfigId = connection.id
          } else {
            this.selectedConfigId = null
          }
        } else {
          this.selectedConfigId = null
        }
        this.searchProductName = query.productName !== undefined ? query.productName : ''
        this.searchAppProduct = query.searchProduct !== undefined ? query.searchProduct : ''
        if (query.mappingStatus) {
          this.mappingStatus = query.mappingStatus
        } else if (query.isMapped !== undefined) {
          if (query.isMapped === 'true' || query.isMapped === true || query.isMapped === '1') {
            this.mappingStatus = 'mapped'
          } else if (
            query.isMapped === 'false' ||
            query.isMapped === false ||
            query.isMapped === '0'
          ) {
            this.mappingStatus = 'unmapped'
          } else {
            this.mappingStatus = 'all'
          }
        } else {
          this.mappingStatus = 'all'
        }
        this.hasShopeeStockFilter = this.parseOptionalStockFilter(query.hasShopeeStock)
        this.hasAppStockFilter = this.parseOptionalStockFilter(query.hasAppStock)
        if (query.page) {
          const page = parseInt(query.page, 10)
          this.currentPage = isNaN(page) ? 1 : page
        } else {
          this.currentPage = 1
        }
      },

      updateQueryParams() {
        const query = {}
        if (this.selectedPlatform) {
          query.platform = this.selectedPlatform
        }
        if (this.selectedConfigId) {
          query.configId = this.selectedConfigId
        }
        if (this.searchProductName?.trim()) {
          query.productName = this.searchProductName.trim()
        }
        if (this.searchAppProduct?.trim()) {
          query.searchProduct = this.searchAppProduct.trim()
        }
        if (this.mappingStatus && this.mappingStatus !== 'all') {
          query.mappingStatus = this.mappingStatus
        }
        if (this.hasShopeeStockFilter && this.hasShopeeStockFilter !== 'all') {
          query.hasShopeeStock = this.hasShopeeStockFilter
        }
        if (this.hasAppStockFilter && this.hasAppStockFilter !== 'all') {
          query.hasAppStock = this.hasAppStockFilter
        }
        if (this.currentPage > 1) {
          query.page = this.currentPage
        }
        this.$router.push({
          name: 'platform-integration-products',
          query,
        }).catch(() => {})
      },

      onPlatformChange() {
        this.selectedConfigId = null
        this.searchProductName = ''
        this.searchAppProduct = ''
        this.mappingStatus = 'all'
        this.hasShopeeStockFilter = 'all'
        this.hasAppStockFilter = 'all'
        this.syncResult = null
        this.products = []
        this.totalItems = 0
        this.currentPage = 1
        this.updateQueryParams()
      },

      onShopChange() {
        this.syncResult = null
        this.currentPage = 1
        this.updateQueryParams()
      },

      handleApplyFilter() {
        this.currentPage = 1
        this.updateQueryParams()
      },

      handleClearFilter() {
        this.searchProductName = ''
        this.searchAppProduct = ''
        this.mappingStatus = 'all'
        this.hasShopeeStockFilter = 'all'
        this.hasAppStockFilter = 'all'
        this.currentPage = 1
        this.updateQueryParams()
      },

      onPageChange(page) {
        this.currentPage = page
        this.updateQueryParams()
      },

      async fetchProducts() {
        if (!this.selectedConfigId) return

        try {
          this.loadingProducts = true
          this.error = null

          const filters = {}
          if (this.searchProductName?.trim()) {
            filters.productName = this.searchProductName.trim()
          }
          if (this.searchAppProduct?.trim()) {
            filters.searchProduct = this.searchAppProduct.trim()
          }
          if (this.mappingStatus && this.mappingStatus !== 'all') {
            filters.mappingStatus = this.mappingStatus
          }
          if (this.hasShopeeStockFilter && this.hasShopeeStockFilter !== 'all') {
            filters.hasShopeeStock = this.hasShopeeStockFilter === 'true'
          }
          if (this.hasAppStockFilter && this.hasAppStockFilter !== 'all') {
            filters.hasAppStock = this.hasAppStockFilter === 'true'
          }
          const response = await platformRepository.getAllProducts(
            this.selectedConfigId,
            this.selectedPlatform,
            this.currentPage,
            this.pageSize,
            filters,
          )

          this.products = (response.products || []).map((item) => ({
            id: item.platformProduct.id,
            platformProductId: item.platformProduct.platformProductId,
            platformSku: item.platformProduct.platformSku,
            productName: item.platformProduct.productName,
            productDescription: item.platformProduct.productDescription,
            price: item.platformProduct.price,
            currency: item.platformProduct.currency,
            images: item.platformProduct.images,
            platform: this.selectedPlatform,
            mapping: item.mapping,
            clickbuyProduct: item.clickbuyProduct,
            linkedStoreId: item.linkedStoreId ?? null,
            linkedStoreStock:
              item.mapping != null
                ? Number(item.linkedStoreStock) || 0
                : null,
            isSyncInventory: item.platformProduct?.isSyncInventory ?? item.isSyncInventory ?? true,
            shopeeStock: item.shopeeStock ?? 0,
            clickbuyTotalStock: item.clickbuyTotalStock ?? 0,
          }))
          this.totalItems = response.pagination?.total || 0
        } catch (error) {
          console.error('Error loading products:', error)
          this.error = 'Không thể tải danh sách sản phẩm. Vui lòng thử lại.'
          this.makeToastFailure('Lỗi khi tải danh sách sản phẩm')
        } finally {
          this.loadingProducts = false
        }
      },


      async handleSyncAll(syncInventory = true) {
        if (!this.selectedConfigId) return

        try {
          this.syncing = true
          this.syncResult = null

          const result = await platformRepository.syncProducts(this.selectedConfigId, syncInventory)

          if (result?.queued === true) {
            const modeText = syncInventory ? 'đồng bộ kèm tồn kho' : 'đồng bộ không tồn kho'
            this.makeToastSuccess(
              `Yêu cầu ${modeText} đã được thêm vào hàng đợi. Danh sách sẽ cập nhật sau khi xử lý xong.`,
            )
          } else {
            this.syncResult = result

            const modeText = syncInventory ? 'đồng bộ kèm tồn kho' : 'đồng bộ không tồn kho'
            this.$bvToast.toast(`Đã ${modeText}: ${result.totalProducts ?? 0} sản phẩm`, {
              title: 'Đồng bộ thành công',
              variant: 'success',
              solid: true,
              autoHideDelay: 3000,
            })
          }

          this.currentPage = 1
          this.updateQueryParams()
        } catch (error) {
          console.error('Error syncing products:', error)
          this.makeToastFailure(
            error.response?.data?.message || 'Không thể đồng bộ sản phẩm. Vui lòng thử lại.',
          )
        } finally {
          this.syncing = false
        }
      },

      isSyncing(productId) {
        return this.syncingProductIds.has(productId)
      },

      isUpdatingSyncInventory(platformProductId) {
        return this.updatingIsSyncIds.has(platformProductId)
      },

      async handleIsSyncInventoryChange(product, isSyncInventory) {
        const platformProductId = product.platformProductId || product.id
        if (!platformProductId) return

        try {
          this.updatingIsSyncIds.add(platformProductId)
          await platformRepository.updateIsSyncInventory(
            platformProductId,
            !!isSyncInventory,
            this.selectedConfigId,
          )
          this.makeToastSuccess(
            isSyncInventory ? 'Đã bật đồng bộ tồn kho' : 'Đã tắt đồng bộ tồn kho',
          )
          const idx = this.products.findIndex((p) => p.id === product.id)
          if (idx !== -1) {
            this.$set(this.products[idx], 'isSyncInventory', !!isSyncInventory)
          }
        } catch (error) {
          console.error('Error updating isSyncInventory:', error)
          this.makeToastFailure(
            error.response?.data?.message || 'Không thể cập nhật cài đặt đồng bộ tồn kho',
          )
        } finally {
          this.updatingIsSyncIds.delete(platformProductId)
        }
      },

      async handleSyncSingle(product) {
        try {
          this.syncingProductIds.add(product.id)

          const response = await platformRepository.syncSingleProduct(product.id)
          const data = response.data || {}
          if (data.success && data.mapped) {
            this.makeToastSuccess(
              `Đã liên kết thành công với sản phẩm: ${data.clickbuyProduct?.productCode || 'N/A'}`,
            )

            const productIndex = this.products.findIndex((p) => p.id === product.id)
            if (productIndex !== -1) {
              this.$set(this.products, productIndex, {
                ...this.products[productIndex],
                mapping: {
                  clickbuyProductId: response.clickbuyProduct?.id,
                  mappingType: 'AUTO_CODE',
                },
                clickbuyProduct: response.clickbuyProduct,
              })
            }
          } else {
            this.makeToastWarning(response.message || 'Không thể tự động liên kết sản phẩm này')
          }
        } catch (error) {
          console.error('Error syncing single product:', error)
          const errorMessage =
            error.response?.data?.message || error.message || 'Có lỗi xảy ra khi sync sản phẩm'
          this.makeToastFailure(errorMessage)
        } finally {
          this.syncingProductIds.delete(product.id)
        }
      },

      navigateBack() {
        this.$router.push({ name: 'platform-integration-list' })
      },

      getProductImage(item) {
        if (item.images && Array.isArray(item.images) && item.images.length > 0) {
          return item.images[0]
        }
        return null
      },

      getClickbuyProductNameDisplay(item) {
        const name = item?.clickbuyProduct?.productName
        if (name == null || String(name).trim() === '') {
          return '...'
        }
        return String(name).trim()
      },

      isClickbuyProductNameEmpty(item) {
        const name = item?.clickbuyProduct?.productName
        return name == null || String(name).trim() === ''
      },

      getPlatformName(platform) {
        const names = {
          shopee: 'Shopee',
          tiktok: 'TikTok Shop',
        }
        return names[platform] || platform
      },

      formatPrice(price, currency = 'VND') {
        if (!price) return '-'

        const formattedPrice = new Intl.NumberFormat('vi-VN').format(price)

        if (currency === 'VND') {
          return `${formattedPrice}₫`
        }
        return `${formattedPrice} ${currency}`
      },
    },
  }
</script>

<style lang="scss" scoped>
  .product-management-page {
  &__header {
    margin-bottom: 1rem;
  }

  &__controls {
    background: white;
    border-radius: 4px;
    border: 1px solid #e9ecef;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  }

  &__controls-body {
    padding: 1.25rem 1.5rem 1.35rem;
  }

  &__filter-head {
    margin-bottom: 1rem;
  }

  &__filter-title {
    display: inline-block;
    font-size: 0.6875rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #6c757d;
  }

  &__filter-grid {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
    align-items: flex-start;

    > [class*='col'] {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }

    &--row2 {
      margin-top: 0.75rem;
      padding-top: 0.75rem;
      border-top: 1px dashed #dee2e6;

      @media (min-width: 992px) {
        margin-top: 1rem;
        padding-top: 1rem;
      }
    }
  }

  &__filter-field {
    :deep(label) {
      margin-bottom: 0.35rem;
    }
  }

  &__filter-hint {
    display: block;
    font-size: 0.6875rem;
    line-height: 1.35;
    color: #868e96;
    margin-top: 0.3rem;
  }

  &__filter-spacer {
    pointer-events: none;
  }

  &__filter-label {
    font-size: 0.8125rem;
    font-weight: 500;
    color: #495057;
  }

  &__filter-control {
    width: 100%;
    min-width: 0;
  }

  &__filter-toolbar-divider {
    margin: 1.125rem 0 1rem;
    border: 0;
    border-top: 1px solid #e9ecef;
  }

  &__toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem 1rem;
  }

  &__toolbar-group {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;

    .btn {
      white-space: nowrap;
      margin-right: 0 !important;
    }

    &--sync {
      @media (max-width: 575.98px) {
        width: 100%;
        flex-direction: column;
        align-items: stretch;

        .btn {
          justify-content: center;
        }
      }
    }
  }

  &__sync-stats {
    padding: 0.5rem;
    background: #f8f9fa;
    border-radius: 4px;
    font-size: 0.875rem;
  }

  &__table {
    background: white;
    border-radius: 4px;
  }

  &__empty {
    background: white;
    border-radius: 4px;
    padding: 2rem;

    .icon-3x {
      font-size: 3rem;
      display: block;
    }
  }

  &__product-names {
    line-height: 1.45;
  }

  &__name-line {
    display: block;
    font-size: 0.875rem;

    &--system {
      margin-top: 0.25rem;
    }
  }

  &__name-label {
    color: #6c757d;
    font-size: 0.75rem;
    margin-right: 0.25rem;
  }

  &__name-value {
    font-size: 0.875rem;
    word-break: break-word;

    &--display {
      font-weight: 600;
      color: #212529;
    }
  }

  &__name-platform {
    font-size: 0.75rem;
  }

  :deep(td.product-management-page__name-cell) {
    vertical-align: top;
    min-width: 220px;
    max-width: 420px;
  }

  &__image {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      border-radius: 4px;
    }

    &-placeholder {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f8f9fa;
      border-radius: 4px;
      color: #6c757d;
      font-size: 1.5rem;
    }
  }

  :deep(.table) {
    td {
      vertical-align: middle;
    }
  }
}

@media (max-width: 1200px) {
  .product-management-page {
    &__toolbar {
      flex-direction: column;
      align-items: stretch;
    }

    &__toolbar-group {
      width: 100%;
      justify-content: flex-start;
    }

    &__toolbar-group--sync {
      padding-top: 0.5rem;
      border-top: 1px solid #f1f3f5;
    }
  }
}
</style>

